import lrTitle from './_src/lrTitle.vue'
lrTitle.install = function(Vue) {
  Vue.component(lrTitle.name, lrTitle)
}
export default lrTitle